export default "__VITE_ASSET__cb1eb2d5__"